/**
 * @file view-product-variants.tsx
 * @deprecated Copied to app/modules/procurement/pages/master/product-variants/view-product-variants.tsx. This file still serves the existing /UProcure routes.
 * @module uProcure/master/product-variants/view-product-variants
 * @description This is the file where product variants can be viewed in details. The data is shown in tabs based on
 * the variant categories. The linked categories and their details are shown in an accordion inside each tab.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 2.1.2
 *
 * @todo Warehouse refetch: fetchTabs/fetchActiveTabData run on mount only; refetch when
 *   selectedWarehouse changes so variant tiles and tab data match active warehouse.
 * @todo Duplicate page titles: uProcure/master/index.tsx uses PageTitle on routes; this
 *   component also renders h1 — remove one.
 * @todo Route-level permission guard: component uses history.back() on mount only; add
 *   ProductVariants permission check in PrivateRoutes or route wrapper if required.
 * @todo add-product-variants checks hasPermission(Add) only; uprocure-admin also gates with
 *   hasModulePermission(ProductVariants) — align permission checks across add/edit/view.
 * @todo product-variants.tsx is an unrouted empty-state stub; live list is this file —
 *   remove duplicate stub or wire it intentionally.
 */

import { Card, Col, Nav, Row, Tab, Table } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import ThreeDotMenu from "../../../../../_admin/assets/media/svg_uTrade/three-dot.svg";
import { useEffect, useState } from "react";
import APICallService from "../../../../../api/apiCallService";
import { master } from "../../../../../api/apiEndPoints";
import Loader from "../../../../../Global/loader";
import { variantsJSON } from "../../../../../api/apiJSON/master";
import { CustomSelectTable } from "../../../../custom/Select/CustomSelectTable";
import {
  Add,
  Delete,
  Edit,
  ProductVariants,
  SuggestOptions,
} from "../../../../../utils/constants";
import { listVariants } from "../../../../../utils/storeString";
import { getKey, setKey } from "../../../../../Global/history";
import { masterToast } from "../../../../../utils/toast";
import { success } from "../../../../../Global/toast";
import DeleteModal from "../../../../modals/delete";
import { ElementAnimateUtil } from "../../../../../_admin/assets/ts/_utils";
import { useAuth } from "../../../auth";
import Method from "../../../../../utils/methods";
import { useWarehouse } from "../../../../context/WarehouseContext";
const ViewProductVariants = () => {
  const { selectedWarehouse } = useWarehouse();
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const [tabs, setTabs] = useState([]);
  const [activeTabData, setActiveTabData] = useState<any>([]);
  const [fetchLoader, setFetchLoader] = useState(false);
  const [dataFetched, setDataFetched] = useState(false);
  const [loading, setLoading] = useState(false);
  const [active, setActive] = useState(0);
  const [tabId, setTabId] = useState<any>("");
  const [id, setId] = useState(-1);
  const [variantId, setVariantId] = useState("");
  const [show, setShow] = useState(false);
  const [selectedVariant, setSelectedVariant] = useState<any>([]);
  const [deleteVariantModalOpen, setDeleteVariantModalOpen] = useState(false);
  const [selectedSubvariant, setSelectedSubVariant] = useState<any>([]);
  const [deleteSubVariantModalOpen, setDeleteSubVariantModalOpen] =
    useState(false);
  const [error, setError] = useState("");
  const [deleteLoader, setDeleteLoader] = useState(false);

  const handleActive = async (event: any, id: string) => {
    setActive(event);
    setKey(listVariants.currentTab, event);
    setKey(listVariants.currentTabId, id.toString(), false);
    setTabId(id);
    await fetchActiveTabData(id);
    setLoading(false);
  };
  useEffect(() => {
    (async () => {
      if (!Method.hasModulePermission(ProductVariants, currentUser)) {
        return window.history.back();
      }
      await fetchTabs();
      setDataFetched(true);
    })();
  }, []);

  useEffect(() => {
    if (dataFetched) {
      let initialScrollPosition: any = getKey(listVariants.scrollPosition);
      if (initialScrollPosition) {
        ElementAnimateUtil.scrollTo(parseInt(initialScrollPosition));
        setDataFetched(false);
      }
    }
  }, [dataFetched]);

  const fetchTabs = async () => {
    setFetchLoader(true);
    let apiService = new APICallService(
      master.variantTiles,
      "",
      "",
      "",
      "",
      "",
      ProductVariants,
      selectedWarehouse?.value || null,
    );
    let response = await apiService.callAPI();
    if (response.records) {
      setTabs(response.records);
      // await fetchActiveTabData(response.records[0]._id);
      // setId(response.records[0]._id);
      if (getKey(listVariants.currentTabId)) {
        let key: any = getKey(listVariants.currentTabId);
        await fetchActiveTabData(key);
        setTabId(key);
      } else {
        await fetchActiveTabData(response.records[0]._id);
        setTabId(response.records[0]._id);
      }
    }
    setFetchLoader(false);
  };
  const fetchActiveTabData = async (id: string) => {
    setLoading(true);
    let apiService = new APICallService(
      master.variantInfo,
      variantsJSON.variantInfo({
        viewType: 1,
      }),
      { id: id },
      "",
      "",
      "",
      ProductVariants,
      selectedWarehouse?.value || null,
    );
    let response = await apiService.callAPI();
    if (response) {
      setActiveTabData(response);
    }
    setLoading(false);
  };

  const openMenuOnClick = async (data: any) => {
    setId(data);
    setShow(true);
  };
  const onMenuClose = async () => {
    setId(-1);
    setShow(false);
  };
  const onMenuOpen = async (id: any) => {
    setId(id);
    setShow(true);
  };

  const handleVariantOption = async (event: any, data: any) => {
    if (event.value === 1) {
      navigate("/UProcure/master/product-variants/edit-product-variants", {
        state: tabId,
      });
    } else if (event.value === 2) {
      setDeleteVariantModalOpen(true);
      setSelectedVariant(data);
    } else if (event.value === 0) {
    }
  };

  const handleVariantDelete = async () => {
    setDeleteLoader(true);
    let apiService = new APICallService(
      master.deleteVariants,
      selectedVariant._id,
      "",
      "",
      "",
      true,
      ProductVariants,
      selectedWarehouse?.value || null,
    );
    let response = await apiService.callAPI();
    if (response.error) {
      setError(response.error);
    } else {

      setKey(listVariants.currentTabId, "", false);
      fetchTabs();
      success(masterToast.deleteVariant);
      setDeleteVariantModalOpen(false);
    }
    setDeleteLoader(false);
  };

  const handleVariantModalHide = () => {
    setDeleteVariantModalOpen(false);
    setError("");
  };

  const handleSubVariantOption = async (
    event: any,
    index: number,
    variantVal: any,
    data: any,
  ) => {
    let currentScrollY = window.scrollY;
    setKey(listVariants.scrollPosition, currentScrollY);
    if (event.value === 1) {
      navigate("/UProcure/master/product-variants/edit-product-variants", {
        state: tabId,
      });
    } else if (event.value === 2) {
      setDeleteSubVariantModalOpen(true);
      setSelectedSubVariant(data);
      setVariantId(variantVal._id);
    } else if (event.value === 0) {
    }
  };

  const handleSubVariantDelete = async () => {
    setDeleteLoader(true);
    let subVariantId = selectedSubvariant?._id;
    let apiService = new APICallService(
      master.deleteSubVariants,
      "",
      { tabId, variantId, subVariantId },
      "",
      "",
      true,
      ProductVariants,
      selectedWarehouse?.value || null,
    );
    let response = await apiService.callAPI();
    if (response.error) {
      setError(response.error);
    } else {

      fetchTabs();
      success(masterToast.deleteVariant);
      setDeleteSubVariantModalOpen(false);
    }
    setDeleteLoader(false);
  };

  const handleSubVariantModalHide = () => {
    setDeleteSubVariantModalOpen(false);
    setError("");
  };

  return (
    <>
      {deleteVariantModalOpen && (
        <DeleteModal
          show={deleteVariantModalOpen}
          onHide={handleVariantModalHide}
          service={selectedVariant}
          handleDelete={handleVariantDelete}
          error={error}
          loading={deleteLoader}
          serviceName="variant"
          message={`Are you sure you want to delete ${selectedVariant.title} variant?`}
          warnMessage={`By continuing, the ${selectedVariant.title} variant will
          be removed permanently`}
        />
      )}
      {deleteSubVariantModalOpen && (
        <DeleteModal
          show={deleteSubVariantModalOpen}
          onHide={handleSubVariantModalHide}
          service={selectedSubvariant}
          handleDelete={handleSubVariantDelete}
          error={error}
          loading={deleteLoader}
          serviceName="variant"
          message={`Are you sure you want to delete ${selectedSubvariant.title} variant?`}
          warnMessage={`By continuing, the ${selectedSubvariant.title} variant will
          be removed permanently`}
        />
      )}
      <div className="p-5">
        <Row className="align-items-center g-3 mb-5">
          <Col xs className="align-self-center">
            <h1 className="fs-22 fw-bolder">Product variants</h1>
          </Col>
          {fetchLoader ? (
            <></>
          ) : tabs.length > 0 ? (
            <Col xs="auto" className="text-right">
              {Method.hasPermission(ProductVariants, Add, currentUser) ? (
                <Link
                  to="/UProcure/master/product-variants/add-product-variants"
                  className="uw-btn uw-btn-primary uw-btn-lg btn btn-primary mh-md-50px btn-lg fs-16 fw-600"
                  data-analytics-event="master_product_variants_add_new_clicked"
                >
                  Add new variant
                </Link>
              ) : (
                <></>
              )}
            </Col>
          ) : (
            <>
              <Col lg={12} className="mt-6">
                {Method.hasPermission(ProductVariants, Add, currentUser) ? (
                  <div className="border border-r10px p-md-9 p-7">
                    <h2 className="fs-22 fw-bolder">Start adding variants!</h2>
                    <p className="fs-18 fw-500 mb-md-8 mb-5">
                      You can add different variants for the products.
                    </p>
                    <Link
                      to="/UProcure/master/product-variants/add-product-variants"
                      className="uw-btn uw-btn-primary uw-btn-lg btn btn-primary btn-lg"
                      data-analytics-event="master_product_variants_add_new_clicked"
                    >
                      Add variant
                    </Link>
                  </div>
                ) : (
                  <></>
                )}
              </Col>
            </>
          )}
        </Row>
        <Row>
          <Col lg={12} className="custom-tabContainer">
            {fetchLoader ? (
              <>
                <div className="d-flex justify-content-center">
                  <Loader loading={fetchLoader} />
                </div>
              </>
            ) : tabs.length > 0 ? (
              <>
                <Tab.Container id="left-tabs-example" defaultActiveKey="1">
                  <Row className="variant-categories">
                    <Col sm={"auto"} className="mb-8">
                      <div className="bg-light border-r8px p-3 px-md-6">
                        <Nav variant="pills">
                          {tabs.map((tabVal: any, index: number) => {
                            return (
                              <Nav.Item key={tabVal._id}>
                                <Nav.Link
                                  eventKey={index}
                                  data-analytics-event="master_product_variants_tab_clicked"
                                  onClick={() => {
                                    handleActive(index, tabVal._id);
                                  }}
                                  active={tabId === tabVal._id}
                                >
                                  {tabVal.title}
                                </Nav.Link>
                              </Nav.Item>
                            );
                          })}
                        </Nav>
                      </div>
                    </Col>
                    <Col lg={12} className="mb-7">
                      <Row className="align-items-center">
                        <Col sm>
                          <h3 className="fs-22 fw-bolder mb-sm-0 mb-3">
                            Linked categories
                          </h3>
                        </Col>
                        {/* <Col sm="auto">
                          <div className="d-inline-flex">
                            <Button
                              variant="light-primary"
                              size="lg"
                              className="mh-md-50px me-md-5 me-3"
                            >
                              Manage this variant
                            </Button>
                            <img src={ThreeDot} alt="" />
                          </div>
                        </Col> */}
                        <Col xs={"auto"}>
                          <div className="my-0 bg-light float-end">
                            {Method.hasPermission(
                              ProductVariants,
                              Edit,
                              currentUser,
                            ) ||
                            Method.hasPermission(
                              ProductVariants,
                              Delete,
                              currentUser,
                            ) ? (
                              <CustomSelectTable
                                marginLeft={"-90px"}
                                placeholder={
                                  <img
                                    className="me-3"
                                    width={24}
                                    height={5}
                                    src={ThreeDotMenu}
                                    alt=""
                                  />
                                }
                                backgroundColor={"#fff"}
                                options={[
                                  ...(Method.hasPermission(
                                    ProductVariants,
                                    Edit,
                                    currentUser,
                                  )
                                    ? [
                                        {
                                          label: (
                                            <button className="btn btn-link fs-14 fw-500 text-black ms-3 p-4">
                                              Edit
                                            </button>
                                          ),
                                          value: 1,
                                        },
                                      ]
                                    : []),
                                  ...(Method.hasPermission(
                                    ProductVariants,
                                    Delete,
                                    currentUser,
                                  )
                                    ? [
                                        {
                                          label: (
                                            <button
                                              className="btn btn-link fs-14 fw-500 text-danger ms-3 p-4"
                                              data-analytics-event="master_product_variants_delete_details_clicked"
                                            >
                                              Delete
                                            </button>
                                          ),
                                          value: 2,
                                        },
                                      ]
                                    : []),
                                ]}
                                show={tabId === id}
                                onMenuClose={() => {
                                  onMenuClose();
                                }}
                                openMenuOnClick={() => {
                                  openMenuOnClick(tabId);
                                }}
                                onMenuOpen={() => {
                                  onMenuOpen(tabId);
                                }}
                                onChange={(event: any) => {
                                  handleVariantOption(event, activeTabData);
                                }}
                                isOptionDisabled={(option: any) =>
                                  option.value === 3
                                }
                              />
                            ) : (
                              <></>
                            )}
                          </div>
                        </Col>
                      </Row>
                    </Col>
                    <Col lg={12}>
                      <Tab.Content>
                        {/*TAB-1*/}
                        {loading ? (
                          <>
                            <div className="d-flex justify-content-center">
                              <Loader loading={loading} />
                            </div>
                          </>
                        ) : (
                          <>
                            {" "}
                            <Tab.Pane eventKey={active} active={true}>
                              <Card className="card-custom categories-card border border-r10px">
                                <Card.Header className="min-h-65px">
                                  <h3 className="card-title fs-16 fw-600">
                                    Categories
                                  </h3>
                                </Card.Header>
                                <Card.Body className="p-0">
                                  {activeTabData.categories?.map(
                                    (activeVal: any, index: number) => (
                                      <div
                                        className="accordion"
                                        id={"kt_accordion_" + activeVal._id}
                                      >
                                        <div className="accordion-item">
                                          <div
                                            className="accordion-header"
                                            id={"accordion_" + activeVal._id}
                                          >
                                            <Row className="align-items-center p-0">
                                              <Col xs>
                                                <button
                                                  className="accordion-button fs-16 fw-600 pe-0 border-bottom-0 collapsed"
                                                  type="button"
                                                  data-analytics-event="master_product_variants_category_accordion_clicked"
                                                  data-bs-toggle="collapse"
                                                  data-bs-target={
                                                    "#body_accordion_" +
                                                    activeVal._id
                                                  }
                                                  aria-expanded="false"
                                                  aria-controls={
                                                    "body_accordion_" +
                                                    activeVal._id
                                                  }
                                                >
                                                  <span className="symbol symbol-35px border bg-body border-r8px me-3">
                                                    <img
                                                      className="img-fluid"
                                                      src={activeVal.image}
                                                      alt=""
                                                    />
                                                  </span>
                                                  <span className="w-100">
                                                    {activeVal.title}
                                                  </span>
                                                </button>
                                              </Col>
                                              <Col xs={"auto"}></Col>
                                            </Row>
                                          </div>{" "}
                                          <div
                                            id={
                                              "body_accordion_" + activeVal._id
                                            }
                                            className="accordion-collapse collapse"
                                          >
                                            <div className="d-flex justify-content-between">
                                              <div className="table-responsive-md linked-categories w-100">
                                                <Table className="align-middle border-bottom-table fs-15 fw-600 mb-0">
                                                  <thead>
                                                    <tr>
                                                      <th className="p-0 min-w-275px"></th>
                                                      <th className="p-0 min-w-200px"></th>
                                                      <th className="p-0 min-w-400px"></th>
                                                      <th className="p-0"></th>
                                                    </tr>
                                                  </thead>
                                                  <tbody>
                                                    {activeVal.categories
                                                      .length > 0 &&
                                                      activeVal.categories.map(
                                                        (
                                                          subVal: any,
                                                          subIndex: number,
                                                        ) => {
                                                          return (
                                                            <>
                                                              <tr>
                                                                <td>
                                                                  <div className="d-flex justify-content-center align-items-center fs-16 fw-600">
                                                                    <span className="symbol symbol-35px border bg-body border-r8px me-3">
                                                                      <img
                                                                        className="img-fluid p-1"
                                                                        src={
                                                                          subVal.image
                                                                        }
                                                                        alt=""
                                                                      />
                                                                    </span>
                                                                    {
                                                                      subVal.title
                                                                    }
                                                                  </div>
                                                                </td>
                                                                <td>
                                                                  {subVal
                                                                    .variant
                                                                    .definedBy ===
                                                                  SuggestOptions
                                                                    ? "Suggest options"
                                                                    : "Text guide"}
                                                                </td>
                                                                <td>
                                                                  {subVal
                                                                    .variant
                                                                    .definedBy ===
                                                                    SuggestOptions}
                                                                  {subVal
                                                                    .variant
                                                                    .definedBy ===
                                                                  SuggestOptions ? (
                                                                    <div className="row gy-3">
                                                                      {subVal.variant.options.map(
                                                                        (
                                                                          optionVal: any,
                                                                        ) => {
                                                                          return (
                                                                            <div className="col-auto w-fit-content">
                                                                              <div className="bg-gray-100 p-4 px-5 pills-radius">
                                                                                <span className="fw-600 text-black fs-16">
                                                                                  {
                                                                                    optionVal.title
                                                                                  }
                                                                                </span>
                                                                              </div>
                                                                            </div>
                                                                          );
                                                                        },
                                                                      )}
                                                                    </div>
                                                                  ) : (
                                                                    subVal
                                                                      .variant
                                                                      .note
                                                                  )}
                                                                </td>
                                                                <td className="text-end">
                                                                  <div className="my-0 bg-light float-end">
                                                                    {Method.hasPermission(
                                                                      ProductVariants,
                                                                      Edit,
                                                                      currentUser,
                                                                    ) ||
                                                                    Method.hasPermission(
                                                                      ProductVariants,
                                                                      Delete,
                                                                      currentUser,
                                                                    ) ? (
                                                                      <CustomSelectTable
                                                                        marginLeft={
                                                                          "-90px"
                                                                        }
                                                                        width={
                                                                          "auto"
                                                                        }
                                                                        placeholder={
                                                                          <img
                                                                            className="me-3"
                                                                            width={
                                                                              24
                                                                            }
                                                                            height={
                                                                              5
                                                                            }
                                                                            src={
                                                                              ThreeDotMenu
                                                                            }
                                                                            alt=""
                                                                          />
                                                                        }
                                                                        options={[
                                                                          ...(Method.hasPermission(
                                                                            ProductVariants,
                                                                            Edit,
                                                                            currentUser,
                                                                          )
                                                                            ? [
                                                                                {
                                                                                  label:
                                                                                    (
                                                                                      <button className="btn btn-link fs-14 fw-500 text-black ms-3 p-4">
                                                                                        Edit
                                                                                      </button>
                                                                                    ),
                                                                                  value: 1,
                                                                                },
                                                                              ]
                                                                            : []),
                                                                          ...(Method.hasPermission(
                                                                            ProductVariants,
                                                                            Delete,
                                                                            currentUser,
                                                                          )
                                                                            ? [
                                                                                {
                                                                                  label:
                                                                                    (
                                                                                      <button className="btn btn-link fs-14 fw-500 text-danger ms-3 p-4">
                                                                                        Delete
                                                                                      </button>
                                                                                    ),
                                                                                  value: 2,
                                                                                },
                                                                              ]
                                                                            : []),
                                                                        ]}
                                                                        backgroundColor="white"
                                                                        show={
                                                                          show &&
                                                                          index ===
                                                                            id
                                                                        }
                                                                        onMenuClose={() => {
                                                                          onMenuClose();
                                                                        }}
                                                                        openMenuOnClick={() => {
                                                                          openMenuOnClick(
                                                                            index,
                                                                          );
                                                                        }}
                                                                        onMenuOpen={() => {
                                                                          onMenuOpen(
                                                                            index,
                                                                          );
                                                                        }}
                                                                        onChange={(
                                                                          event: any,
                                                                        ) => {
                                                                          handleSubVariantOption(
                                                                            event,
                                                                            index,
                                                                            activeVal,
                                                                            subVal,
                                                                          );
                                                                        }}
                                                                        isOptionDisabled={(
                                                                          option: any,
                                                                        ) =>
                                                                          option.value ===
                                                                          3
                                                                        }
                                                                      />
                                                                    ) : (
                                                                      <></>
                                                                    )}
                                                                  </div>
                                                                </td>
                                                              </tr>
                                                            </>
                                                          );
                                                        },
                                                      )}
                                                  </tbody>
                                                </Table>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    ),
                                  )}{" "}
                                </Card.Body>
                              </Card>
                            </Tab.Pane>
                          </>
                        )}
                      </Tab.Content>
                    </Col>
                  </Row>
                </Tab.Container>
              </>
            ) : (
              <></>
            )}
          </Col>
        </Row>
      </div>
    </>
  );
};
export default ViewProductVariants;
